export default {
  defaultSortField: 'name',
  defaultSortOrder: 'asc',
  rearrangeCols: false,
  isCheckable: true,
  hasCheckBox: true,
  isDetailed: false,
  customRowKey: 'uid',
  fields: [{
    name: 'field-generic-input',
    prop: 'name',
    width: '400px',
    title: 'Item',
    id: 'name',
  }, {
    name: 'qty-available',
    prop: 'quantity',
    width: '15%',
    title: 'QTY Current Delivery',
    id: 'quantity',
  },
  {
    name: 'qty-needed',
    prop: 'selectedQty',
    width: '15%',
    title: 'Qty Split Delivery',
    id: 'selectedQty',
  }],
};
